import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import * as AuthenticationService from '../services/AuthenticationService.js';
import LoginStatusType from '../objects/LoginStatusType.js';

Vue.use(VueRouter);

const router = new VueRouter({
  base: JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_PUBLIC_PATH}' : process.env.VUE_APP_PUBLIC_PATH,
  routes,
  mode: 'history',
});

router.beforeEach(async (to, from, next) => {
  router.app.$options.store.commit('setNavigation', to.meta);
  if (to.meta.verifyAuth) {
    const status = await AuthenticationService.VerifyAsync();
    if (status !== LoginStatusType.Success) {
      next({ name: 'Login', query: { redirect: to.path } });
      return;
    }
  }

  if (to.matched.length > 0) {
    next();
  } else {
    next({ name: 'FeatureNotFound' });
  }
});

export default router;
